import Icon from "@Atom/Icon";
import Styles from "./styles.module.scss";
import { useMemo, useState } from "react";
import { Skeleton, Tooltip } from "@mui/material";
import Spinner from "@Atom/Spinner";

export default function JobSeekersCard({
  data,
  isHistory = false,
  setShowDetail = () => {},
  loading = false,
  onClickArchiveIcon = () => {},
  isLoadingBookmarkedIcon = false,
}) {
  const [onHover, setOnhover] = useState(false); // disabled
  const startIndex = 0;
  const endIndex = 1;

  const maxLengthAddress = 28;

  function formatNumber(num) {
    if (num >= 1e12) {
      return (num / 1e12).toFixed(2).replace(/\.?0+$/, "") + "T";
    } else if (num >= 1e9) {
      return (num / 1e9).toFixed(2).replace(/\.?0+$/, "") + "M";
    } else if (num >= 1e6) {
      return (num / 1e6).toFixed(2).replace(/\.?0+$/, "") + "jt";
    } else if (num >= 1e3) {
      return (num / 1e3).toFixed(2).replace(/\.?0+$/, "") + "rb";
    } else {
      return num.toString();
    }
  }

  const slicedItems = useMemo(() => {
    if (data?.location?.length > 1) {
      return data?.location?.slice(endIndex);
    }
  }, [data?.location]);

  const selectedItems = useMemo(() => {
    if (data?.location?.length > 0) {
      return data?.location?.slice(startIndex, endIndex);
    }
    return [];
  }, [data?.location]);

  function toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  function changeFormatPlacement(str) {
    return str.replaceAll("::", ", ");
  }

  return (
    <div
      className={`${Styles.container} ${!loading && Styles.cursor}`}
      onClick={(e) => {
        if (!loading) {
          e.stopPropagation();
          setShowDetail();
        }
      }}
    >
      {isHistory && (
        <div
          className={`${Styles.header} ${
            data?.status === "Proses Interview HR" ||
            data?.status === "Proses Interview User"
              ? Styles.yellow
              : ""
          } ${data.status === "Penawaran Kerja" ? Styles.purple : ""} ${
            data?.status === "Tanda Tangan Kontrak" && Styles.pink
          } ${data?.status === "Diterima Bekerja" && Styles.green} ${
            data?.status === "Lamaran Tidak Dilanjutkan" && Styles.red
          }`}
        >
          <span
            className={Styles.status}
            style={{
              width: loading ? "100%" : "",
            }}
          >
            {loading ? <Skeleton width={"50%"} /> : data?.status || "-"}
          </span>

          {data?.viewedAt &&
            (loading ? (
              <Skeleton width={"50%"} />
            ) : (
              <span className={Styles.viewedAt}>
                Lamaran telah dilihat rekruter pada {data?.viewedAt}
              </span>
            ))}
          {data?.isRevision && !loading && (
            <div className={Styles.warning}>
              <div>
                <Icon icon={"alert-solid"} size={16} color={"#FF3E13"} />
              </div>
              <span>{data?.isRevision || "-"}</span>
            </div>
          )}
        </div>
      )}

      {data?.isApply && !isHistory && !loading && (
        <div className={Styles.isApply}>
          <div>
            <Icon icon={"check-circle-2"} size={16} color={"#1571DE"} />
          </div>
          <span>Sudah Dilamar</span>
        </div>
      )}

      <div className={Styles.content}>
        <div className={Styles.intro}>
          <div
            className={`${Styles.left} ${
              data?.isApply && !isHistory && Styles.opacity
            } `}
          >
            <div className={`${Styles.images}`}>
              {loading ? (
                <Skeleton variant="circular" width={50} height={50} />
              ) : (
                <img src={data?.img} alt="company-logo" />
              )}
            </div>
            <div className={Styles.titleBox}>
              <span>{loading ? <Skeleton /> : data?.name || "-"}</span>
              <span>{loading ? <Skeleton /> : data?.experience || "-"}</span>
            </div>
          </div>

          {!isHistory && !loading && (
            <div
              style={{
                cursor: data?.isApply ? "not-allowed" : "",
              }}
              className={Styles.right}
              onClick={(e) => {
                e.stopPropagation();
                onClickArchiveIcon();
              }}
            >
              {isLoadingBookmarkedIcon ? (
                <Spinner />
              ) : (
                <Icon
                  icon={"bookmark"}
                  size={24}
                  color={
                    data?.isApply
                      ? "#91bdf1"
                      : data?.isArchived
                      ? "#1571DE"
                      : "#E0E0E0"
                  }
                />
              )}
            </div>
          )}
        </div>

        <div className={Styles.typeBox}>
          {loading ? (
            <Skeleton width={"50px"} />
          ) : data?.workType ? (
            <div>{data?.workType || "-"}</div>
          ) : null}

          {loading ? (
            <Skeleton width={"50px"} />
          ) : data?.workMethod ? (
            <div>{data?.workMethod || "-"}</div>
          ) : null}
          {loading ? (
            <Skeleton width={"50px"} />
          ) : data?.contractType ? (
            <div>{data?.contractType || "-"}</div>
          ) : null}
          {loading ? (
            <Skeleton width={"50px"} />
          ) : data?.workSystem ? (
            <div>{data?.workSystem || "-"}</div>
          ) : null}
        </div>

        <div
          className={Styles.client}
          // onMouseEnter={() => setOnhover(true)}
          // onMouseLeave={() => setOnhover(false)}
          onClick={(e) => {
            if (data?.websiteCompany && !loading) {
              e.stopPropagation();
              window.open(data?.websiteCompany);
            }
          }}
        >
          <div className={Styles.iconBuilding}>
            {loading ? (
              <Skeleton variant="circular" width={20} height={20} />
            ) : (
              <Icon icon={"building"} size={20} color={"#242424"} />
            )}
          </div>
          <span className={`${onHover && Styles.onHover}`}>
            {loading ? <Skeleton width={"50px"} /> : data?.client || "-"}
          </span>
          {onHover && !loading && (
            <div className={Styles.iconHover}>
              <Icon icon={"arrow-up-right"} size={14} color={"#1571DE"} />
            </div>
          )}
        </div>

        <div className={Styles.locationBox}>
          <div className={Styles.left}>
            <div className={Styles.iconMaps}>
              {loading ? (
                <Skeleton variant="circular" width={20} height={20} />
              ) : (
                <Icon icon={"map-pin-solid"} size={20} color={"#242424"} />
              )}
            </div>
            {loading ? (
              <Skeleton width={"50px"} />
            ) : Array.isArray(data?.location) ? (
              <Tooltip
                title={
                  <span>
                    {toTitleCase(
                      changeFormatPlacement(
                        data?.location?.map((item) => item.city).join(", ")
                      )
                    ) || "-"}
                  </span>
                }
              >
                <div className={Styles.placement}>
                  <span>
                    {selectedItems?.length > 0
                      ? selectedItems.map((item) => item.city).join(", ")
                          ?.length > maxLengthAddress
                        ? toTitleCase(
                            changeFormatPlacement(
                              selectedItems.map((item) => item.city).join(", ")
                            )
                          )?.substring(0, maxLengthAddress) + "..."
                        : toTitleCase(
                            changeFormatPlacement(
                              selectedItems.map((item) => item.city).join(", ")
                            )
                          )
                      : "-"}
                  </span>

                  {data?.location?.length > 1 ? (
                    <span className={Styles.slice}>+{slicedItems?.length}</span>
                  ) : null}
                </div>
              </Tooltip>
            ) : (
              <Tooltip title={<span>{data?.location || "-"}</span>}>
                <span>{data?.location || "-"}</span>
              </Tooltip>
            )}
          </div>

          {loading ? (
            <div className={Styles.right}>
              <Skeleton width={"25px"} />
            </div>
          ) : (
            <div className={Styles.right}>
              Rp{" "}
              {data?.salary?.split("-")?.map((s, is, arr) => (
                <span key={is}>
                  {formatNumber(
                    +s
                      ?.replace(".", ",")
                      .replace(/\d{3}(?=(\d{3})*,)/g, function (s) {
                        return "." + s;
                      })
                  )}{" "}
                  {arr.length > 1 && is === 0 && " - "}
                </span>
              ))}
            </div>
          )}
        </div>

        <div className={Styles.footer}>
          <div className={Styles.left}>
            {loading ? (
              <Skeleton />
            ) : isHistory ? (
              <span className={Styles.grey}>
                Dilamar pada : <span>{data?.createdAt || "-"}</span>
              </span>
            ) : (
              <span className={Styles.grey}>{data?.createdAt}</span>
            )}
          </div>

          {isHistory && data?.isShowButton && !loading ? (
            <div
              className={Styles.right}
              onClick={(e) => {
                e.stopPropagation();
                window.open(data?.linkInterview);
              }}
            >
              <button>{data?.isShowButton || "-"}</button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
